import "./index.scss";
import { Search } from "../../ui/molecules/search";
import Mandala from "../../ui/molecules/mandala";

export function HomepageHero() {
  return (
    <div className="homepage-hero dark">
      <section>
        <h1>MDN Web 中文网</h1>
        <p>
          Web 技术文档，包括 CSS、HTML 和 JavaScript。
          
        </p>
        <Search id="hp-search" isHomepageSearch={true} />
      </section>
      <Mandala extraClasses="homepage-hero-bg" />
    </div>
  );
}
